const isUnique = unique => value => {
    return !unique ? `Value must be unique` : undefined
    return undefined;
  }
  
  export default isUnique;